module.exports = __webpack_public_path__ + "3d0c6470186e55f5940fd4497fb8916f.png";